var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    width: 20,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bed-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff385c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m16.7 8.5v-5.5h-1.7v1.7h-10v-1.7h-1.7v5.5c-1 0.5-1.6 1.6-1.6 2.8v3.4q0 0.3 0.2 0.6 0.3 0.2 0.6 0.2h0.8v3.3h1.7v-3.3h10v3.3h1.7v-3.3h0.8q0.3 0 0.6-0.2 0.2-0.3 0.2-0.6v-3.4c0-1.2-0.6-2.3-1.6-2.8zm-1.7-2.2v1.7h-4.2v-1.7zm-10 0h4.2v1.7h-4.2zm11.7 7.5h-13.3v-2.5c0-0.9 0.7-1.7 1.6-1.7h10c1 0 1.7 0.8 1.7 1.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bed-icon.bfa1e6a84f5b770372e833207ae1ffe6.svg";
export { ForwardRef as ReactComponent };